import { ArrowLeft } from 'lucide-react';
import cn from 'classnames';
import LeftBackIcon from '@/assets/icons/left-back.svg?react';

interface BackToLoginLinkProps {
  /** 点击回调 */
  onClick?: () => void;
  /** 自定义类名 */
  className?: string;
  /** 变体：arrow（带箭头）或 icon（带返回图标按钮样式） */
  variant?: 'arrow' | 'icon';
}

/**
 * 返回登录链接组件
 */
export function BackToLoginLink({ onClick, className, variant = 'arrow' }: BackToLoginLinkProps) {
  if (variant === 'icon') {
    return (
      <button
        type="button"
        onClick={onClick}
        className={cn(
          'flex h-[40px] w-full items-center justify-center gap-[8px] rounded-[8px] bg-[#171717] px-[24px] py-[9.5px]',
          'text-[14px] font-medium leading-[1.5] tracking-[0.07px] text-white',
          'hover:bg-[#262626]',
          className
        )}
      >
        <LeftBackIcon className="h-[13.25px] w-[13.25px] [&_path]:fill-white" />
        <span>Back to Log in</span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn('flex items-center gap-[8px] text-[#525252] hover:text-[#171717]', className)}
    >
      <ArrowLeft className="h-[16px] w-[16px]" />
      <span className="text-[14px] font-normal leading-[1.5] tracking-[0.07px]">Back to Log in</span>
    </button>
  );
}

export default BackToLoginLink;
